import { render, staticRenderFns } from "./DetailMedicalInfoPopUp.vue?vue&type=template&id=8e10776a&scoped=true"
import script from "./DetailMedicalInfoPopUp.vue?vue&type=script&lang=js"
export * from "./DetailMedicalInfoPopUp.vue?vue&type=script&lang=js"
import style0 from "./DetailMedicalInfoPopUp.vue?vue&type=style&index=0&id=8e10776a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e10776a",
  null
  
)

export default component.exports